import { MenuGroup } from '@chakra-ui/react'

export default MenuGroup
